import { useState } from 'react'
import { SocialPopUpForGoogleEmailCaptureExperiment } from '@mc/authentication'
import { usePrimaryCta } from '@mc/growth'
import { useStaticData } from '@mc/static-data-react'

export const CustomModal = ({
  onClose,
  isModalBanned,
}: {
  onClose: () => void
  isModalBanned: boolean
}) => {
  const { userAgent } = useStaticData<{ userAgent: string }>()
  const [state, setState] = useState<'show' | 'banned' | 'tap_outside'>('show')
  const { ctaHref } = usePrimaryCta()

  if (isModalBanned || ['banned', 'tap_outside'].includes(state)) return null

  const handleClose = () => {
    setState('banned')
    onClose()
  }

  return (
    <SocialPopUpForGoogleEmailCaptureExperiment
      onDismiss={() => setState('tap_outside')}
      onClose={handleClose}
      userAgent={userAgent}
      nextPage={ctaHref}
    />
  )
}
